// extracted by mini-css-extract-plugin
module.exports = {"PageBody":"common_PageBody__2qLC8"};